import { SearchModel } from "@fry/lib/list"
import { BookingTableCardViewComponent } from "./booking-table-card.view.component"
import { BoardCardType } from "@fry/boards/lib"
import { BookingTableCardSettingsComponent } from "./booking-table-card.settings.component"

export interface BookingTableCardOptions {
    title: string
    searchModel: SearchModel
    fixedSearchModel?: SearchModel
    pageSize?: number
}

export const BookingTableCard: BoardCardType = {
    name: 'booking-table',
    title: $localize `List of bookings`,
    viewComponent: BookingTableCardViewComponent,
    editComponent: BookingTableCardSettingsComponent,
}